<template>
  <PopupBox
    :disable="disable"
    :popup-styles="{ top: 3 }"
    class="partner-filter-wrapper"
    placement="bottom-end"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <h2 :class="clsx('partner-filter', { 'partner-filter--active': hasActiveFilters, 'partner-filter--disabled': disable })">
        <slot />
        <PopupToggler :is-open="popupVisible" :color="calculateTogglerColor" class="ml-2" />
      </h2>
    </template>
    <template>
      <div class="partner-filter-content">
        <PopupMenuList
          class="partner-filter-list"
          :items="items"
          :selected-item="selectedItem"
          :checkbox-style="checkboxStyle"
        />
      </div>
    </template>
  </PopupBox>
</template>

<script>
import { clsx } from 'clsx';
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupToggler, PopupMenuList },
  computed: {
    hasActiveFilters() {
      if (!this.selectedItem?.id) return false;

      const correspondingItem = this.items.find(item => item.id === this.selectedItem.id);
      return correspondingItem?.options?.activeFilter !== false;
    },
    calculateTogglerColor() {
      if (this.disable) {
        return '#6B7280';
      }

      return this.hasActiveFilters ? '#FB923C' : '#09090B';
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.partner-filter {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  &-wrapper {
    display: inline-block;
  }

  &--active {
    color: #FB923C;
  }

  &--disabled {
    cursor: not-allowed;
    color: #6B7280;
  }

  &-list {
    padding-right: 12px;
  }
}
</style>
